import React from 'react'
import { ArrowRight } from '../../icons'

function PageTitle({ children }) {
  return (
    <h1 className="my-6 flex font-semibold text-gray-800">
      {children}
      </h1>
  )
}

export default PageTitle
